import { gql } from '@apollo/client';

import { AppBaseFields } from './apps.fragment';
export * from './appUpdate.mutation.generated';

export const APP_UPDATE = gql`
  mutation appUpdate($input: AppUpdateInput!) {
    appUpdate(input: $input) {
      errors
      success
      app {
        ...AppBaseFields
        description
        industry
        jurisdiction
        softwareType
        kind
        includedApps
        updatedAt
      }
    }
  }
  ${AppBaseFields}
`;
